import { useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";

export interface PageContext {
  route: string;
  catalogId?: number;
  productId?: number;
  feature?: string;
}

/**
 * Hook to detect current page context for AI assistance
 * Extracts route, IDs, and feature from current location
 */
export const usePageContext = (): PageContext => {
  const location = useLocation();
  const params = useParams();

  return useMemo(() => {
    const route = location.pathname;
    const context: PageContext = { route };

    // Extract catalogId from route params
    if (params.catalogId) {
      context.catalogId = parseInt(params.catalogId, 10);
    }

    // Extract productId from route params
    if (params.productId || params.id) {
      const id = params.productId || params.id;
      if (id) {
        context.productId = parseInt(id, 10);
      }
    }

    // Detect feature from route
    if (route.includes("/products")) {
      context.feature = "products";
    } else if (route.includes("/catalogs")) {
      context.feature = "catalogs";
    } else if (route.includes("/design")) {
      context.feature = "designer";
    } else if (route.includes("/showrooms")) {
      context.feature = "showrooms";
    } else if (route.includes("/orders")) {
      context.feature = "orders";
    } else if (route.includes("/inventory")) {
      context.feature = "inventory";
    } else if (route.includes("/import")) {
      context.feature = "import";
    } else if (route.includes("/account")) {
      context.feature = "account";
    }

    return context;
  }, [location.pathname, params]);
};
